import { baseUrl } from "@/configs/menus/meal_registration.menu";

export default [
  {
    path: baseUrl + "/room-breakfast",
    name: "breakfast-registration",
    component: () => import("@/pages/breakfast-registration/Index.vue")
  },
  {
    path: baseUrl + "/room-lunch",
    name: "lunch-registration",
    component: () => import("@/pages/meal-registration/lunch/Index.vue")
  },
  {
    path: baseUrl + "/room-dinner",
    name: "dinner-registration",
    component: () => import("@/pages/meal-registration/dinner/Index.vue")
  },
  {
    path: baseUrl + "/banquet-lunch",
    name: "banquet-lunch-registration",
    component: () => import("@/pages/meal-registration/BanquetLunchRegistration.vue")
  },
  {
    path: baseUrl + "/banquet-dinner",
    name: "banquet-dinner-registration",
    component: () => import("@/pages/meal-registration/BanquetDinnerRegistration.vue")
  },
];
